import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { getDownloadURL, ref, Storage, uploadBytesResumable } from '@angular/fire/storage';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CustomFile } from '../../services/model';

@Component({
  selector: 'app-upload-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatDialogModule,
    MatProgressBarModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
  templateUrl: './upload-dialog.component.html',
  styleUrl: './upload-dialog.component.scss',
})
export class UploadDialogComponent {
  uploadForm: FormGroup;
  uploadProgress: number = 0;
  uploadCompleted: boolean = false;
  uploadedFileUrl: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public path: string,
    private storage: Storage,
    private fb: FormBuilder
  ) {
    this.uploadForm = this.fb.group({
      file: [null],
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const filePath = `${this.path}/${Date.now()}_${file.name}`;
      const storageRef = ref(this.storage, filePath);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.uploadProgress = Math.round(progress);
        },
        error => {
          console.error('Upload failed', error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
            this.uploadedFileUrl = downloadURL;
            this.uploadCompleted = true;
            this.onClose(file.name);
          });
        }
      );
    }
  }

  onClose(fileName: string = ''): void {
    if (this.uploadedFileUrl) {
      const customFile: CustomFile = {
        createdAt: new Date(),
        order: -1,
        name: fileName,
        url: this.uploadedFileUrl,
        type: this.uploadForm.get('file')?.value?.type.includes('pdf') ? 'pdf' : 'image',
      };
      this.dialogRef.close(customFile);
    } else {
      this.dialogRef.close();
    }
  }
}
